module.exports = __webpack_public_path__ + "static/media/diyishitang.f405b0d.ogg";


//////////////////
// WEBPACK FOOTER
// ./static/video/diyishitang.ogg
// module id = skoC
// module chunks = 6